import { render, staticRenderFns } from "./commonSOPDetail.vue?vue&type=template&id=3d002aa6&scoped=true&"
import script from "./commonSOPDetail.vue?vue&type=script&lang=js&"
export * from "./commonSOPDetail.vue?vue&type=script&lang=js&"
import style0 from "./commonSOPDetail.vue?vue&type=style&index=0&id=3d002aa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d002aa6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d002aa6')) {
      api.createRecord('3d002aa6', component.options)
    } else {
      api.reload('3d002aa6', component.options)
    }
    module.hot.accept("./commonSOPDetail.vue?vue&type=template&id=3d002aa6&scoped=true&", function () {
      api.rerender('3d002aa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mass/SOP/components/commonSOPDetail.vue"
export default component.exports